import { default as MuiTableHead } from '@mui/material/TableHead';

/**
 * TableHead contains the header row of a Table.
 *
 * Demos:
 *
 * - [Table](https://unify.workiva.org/components/table?tab=code)
 *
 * API:
 *
 * - [TableHead API](https://unify.workiva.org/components/table?tab=props#tablehead)
 */
export const TableHead = MuiTableHead;
export { type TableHeadProps, tableHeadClasses } from '@mui/material/TableHead';
